<template>
    <div class="explain">
        <div class="panel">
            <div class="slick-wrapper">
                <slick ref="slick" :options="slickOptions" @beforeChange="handleAfterChange">
                    <div class="slide" v-for="( slide, index ) in slides" v-if="destroyCalled ? index === currentSlide : true">
                        <h3>Hoe werkt <br/>Lotto <span class="red">Hoger</span>/<span class="blue">Lager</span></h3>
                        <img :src="'/static/img/slides/' + ( index % 4 ) + '.jpg'" />
                        <p v-html="slide.copy"></p>
                    </div>
                </slick>


                <div class="slider-nav">
                    <div @click="prev" class="arrow"></div>
                    <div class="position">{{ ( currentSlide + 1 ) }}/5</div>
                    <div @click="next" class="arrow"></div>
                </div>
            </div>
        </div>

        <button @click="toGame">Start</button>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>
    import { TimelineMax, screenfull } from '@/vendor';
    import Slick from 'vue-slick';

    export default {
        components: {
            'slick': Slick
        },

        data()
        {
            return {
                slickOptions: {
                    arrows: false,
                    fade: true,
                    useCSS: false
                },

                slides: [
                    {
                        copy: 'Raad 6 keer of de volgende Lotto bal hoger of lager is en maak kans op €4.500!'
                    },
                    {
                        copy: 'Je ziet een bal in beeld, wat denk je? Is de volgende bal hoger of lager? Klik op de bijbehorende pijl. (Tip: Lotto is een spel met 45 ballen)'
                    },
                    {
                        copy: 'Bij 1 goed antwoord maak je al kans op €500. Dit bedrag loopt steeds op, tot zelfs €4.500 bij 6 goede antwoorden!'
                    },
                    {
                        copy: 'Vergeet niet om na afloop je gegevens in te vullen. Je maakt alleen kans als je je gegevens achterlaat.'
                    },
                    {
                        copy: 'De volledige speluitleg en de actievoorwaarden vind je <a href="/static/pdf/lotto_actievoorwaarden.pdf" target="_blank">hier</a>.'
                    }
                ],

                currentSlide: 0,
                destroyCalled: false
            };
        },

        methods: {
            handleAfterChange( pEvent, pSlick, pPreviousSlide, pCurrentSlide )
            {
                this.currentSlide = pCurrentSlide;
            },

            prev()
            {
                this.$refs.slick.prev();
            },

            next()
            {
                this.$refs.slick.next();
            },

            toGame()
            {
                this.destroyCalled = true;
                // this.$refs.slick.destroy();

                if( screenfull.enabled && this.$helpers.browserCheck().isMobile )
                {
                    screenfull.request();
                }

                this.$router.push({ name: 'Game' });
            },

            getAnimateIn()
            {
                let tl = new TimelineMax();

                tl.from( '.panel', 0.3, { y: 50, opacity: 0 });
                tl.from( '.button', 0.3, { opacity: 0 }, 0.3 );

                return tl;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/pages/Explain.vue